<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="JobSchedulerConfigurations"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="overflow-auto h-100 p-3"
    v-if="loaded"
  >
    <ItpBox
      alignItems="center"
      class="mb-3"
    >
      <strong>
        {{ 'Job scheduler configurations'|pgettext('JobSchedulerConfigurations') }}
      </strong>
      <ItpButton
        icon="fa-sync-alt"
        :text="'Reload'|gettext"
        variant="light"
        size="sm"
        :spinning="actions.reload.isRunning"
        class="ml-3"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        :text="'Add schedule...'|pgettext('JobSchedulerConfigurations')"
        variant="light"
        size="sm"
        class="ml-3"
        @click.prevent.stop="evh_6705964765214521_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        icon="fa-file-invoice"
        :text="'Export'|pgettext('JobSchedulerConfigurations')"
        variant="light"
        size="sm"
        :disabled="!items || !items.length"
        use-auth
        force-download
        downloadFileName="job-scheduler-configurations.yaml"
        :href="$fn.urlFor('export_job_scheduler_config')"
        class="ml-3"
      >
      </ItpButton>
      <ItpButton
        icon="fa-file-invoice"
        :text="'Import'|pgettext('JobSchedulerConfigurations')"
        variant="light"
        size="sm"
        class="ml-3"
        @click.prevent.stop="evh_8116269939469002_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <ItpDataTable
      tableId="Settings.JobSchedulerConfigurations"
      :editable="b_3343864469950044_editable"
      :value="items"
      :globs="{ openJobSchedulerConfig }"
      :columns="b_3343864469950044_columns"
      class="h-100"
      ref="table"
      v-if="loaded"
      @save="evh_3343864469950044_save($event, {})"
      @delete="evh_3343864469950044_delete($event, {})"
    >
    </ItpDataTable>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "settings.jobScheduler",
    path: "job-scheduler",
    component: "JobSchedulerConfigurations"
  }
)

@Component()
export default class JobSchedulerConfigurations extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  openJobSchedulerConfig(...args: any[]) {
    const [oid] = args;
    const updateItem = this.updateItem;

    return this.$imodal
      .show({
        name: 'JobSchedulerConfig',
        props: { oid }
      })
      .then(res => {
        console.log(res);
        this.loadData('items')
      })
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_job_scheduler_config')
      .then(items => _.orderBy(items, ['created_at', 'id'], ['asc', 'asd']))
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_3343864469950044_editable!: any;
  b_3343864469950044_columns!: any;
  dataMembers = ['items', 'ux', 'b_7315092382398562_modalBindings', 'b_3343864469950044_editable', 'b_3343864469950044_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_3343864469950044_editable: false,
        b_3343864469950044_columns: [{
          name: "suspended",
          header: this.$fn.pgettext("JobSchedulerConfig", "Suspended"),
          width: "60px",
          formatter: "checkbox",
        }
          ,
        {
          name: "id",
          header: this.$fn.pgettext("JobSchedulerConfig", "ID"),
          width: "180px",
          formatter: {
            name: "template",
            value: "<div>\n\
  <a class=\"text-nowrap\"\n\
     href=\"#\"\n\
     @click=\"globs.openJobSchedulerConfig(row.id)\"\n\
  >\n\
    {{ value }}\n\
  </a>\n\
</div>\n\
",
          }
          ,
        }
          ,
        {
          name: "name",
          header: this.$fn.pgettext("JobSchedulerConfig", "Name"),
          width: "180px",
        }
          ,
        {
          name: "function_name",
          header: this.$fn.pgettext("JobSchedulerConfig", "Function"),
          width: "160px",
        }
          ,
        {
          name: "trigger",
          header: this.$fn.pgettext("JobSchedulerConfig", "Trigger"),
          width: "160px",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_7315092382398562_closeModal_5360_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5360, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_6705964765214521_script_5364_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6705964765214521_script_5364, alias=undefined
    this.openJobSchedulerConfig()
  }

  async act_6705964765214521_script_5364_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6705964765214521_script_5364, alias=undefined
    return {
      value: () => this.act_6705964765214521_script_5364_getActionArgs_value($event),
    }
  }

  async evh_6705964765214521_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6705964765214521_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8116269939469002_showModal_5366_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8116269939469002_showModal_5366, alias=undefined
    return {
      name: "FileSelector",
      props: {
        url: this.$fn.urlFor('import_job_scheduler_config'),
        accept: ".yaml",
      }
      ,
    }
  }

  async evh_8116269939469002_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8116269939469002_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_3343864469950044_script_5368_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3343864469950044_script_5368, alias=undefined
    $event.data.waitFor(this.$fn.crud('job_scheduler_config').upsert({ ...$event.data.row }))
  }

  async act_3343864469950044_script_5368_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3343864469950044_script_5368, alias=undefined
    return {
      value: () => this.act_3343864469950044_script_5368_getActionArgs_value($event),
    }
  }

  async evh_3343864469950044_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_save.executeFromDOM(this, event, scope);
  }

  async act_3343864469950044_script_5370_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3343864469950044_script_5370, alias=undefined
    $event.data.waitFor(this.$fn.crud('job_scheduler_config').delete({ ...$event.data.row }))
  }

  async act_3343864469950044_script_5370_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3343864469950044_script_5370, alias=undefined
    return {
      value: () => this.act_3343864469950044_script_5370_getActionArgs_value($event),
    }
  }

  async evh_3343864469950044_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_delete.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5360: actions.CloseModalAction;
    evh_7315092382398562_close_5359: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_8320016629450276_reloadComponentData_5362: actions.ReloadComponentDataAction;
    evh_8320016629450276_clickPreventStop_5361: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_6705964765214521_script_5364: actions.ScriptAction;
    evh_6705964765214521_clickPreventStop_5363: actions.EventHandlerImpl;
    evh_6705964765214521_clickPreventStop: actions.EventHandlerGroup;
    act_8116269939469002_showModal_5366: actions.ShowModalAction;
    evh_8116269939469002_clickPreventStop_5365: actions.EventHandlerImpl;
    evh_8116269939469002_clickPreventStop: actions.EventHandlerGroup;
    act_3343864469950044_script_5368: actions.ScriptAction;
    evh_3343864469950044_save_5367: actions.EventHandlerImpl;
    evh_3343864469950044_save: actions.EventHandlerGroup;
    act_3343864469950044_script_5370: actions.ScriptAction;
    evh_3343864469950044_delete_5369: actions.EventHandlerImpl;
    evh_3343864469950044_delete: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5360 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5360_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5359 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5360,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5359],
      }
    );
    const act_8320016629450276_reloadComponentData_5362 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_8320016629450276_clickPreventStop_5361 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadComponentData_5362,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_5361],
      }
    );
    const act_6705964765214521_script_5364 = new actions.ScriptAction(
      {
        actionArgs: this.act_6705964765214521_script_5364_getActionArgs,
        events: [],
      }
    );
    const evh_6705964765214521_clickPreventStop_5363 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_script_5364,
        event: "click.prevent.stop",
        displayName: "script",
      }
    );
    const evh_6705964765214521_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6705964765214521_clickPreventStop_5363],
      }
    );
    const act_8116269939469002_showModal_5366 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8116269939469002_showModal_5366_getActionArgs,
        events: [],
      }
    );
    const evh_8116269939469002_clickPreventStop_5365 = new actions.EventHandlerImpl(
      {
        action: act_8116269939469002_showModal_5366,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8116269939469002_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8116269939469002_clickPreventStop_5365],
      }
    );
    const act_3343864469950044_script_5368 = new actions.ScriptAction(
      {
        actionArgs: this.act_3343864469950044_script_5368_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_save_5367 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_script_5368,
        event: "save",
        displayName: "script",
      }
    );
    const evh_3343864469950044_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_save_5367],
      }
    );
    const act_3343864469950044_script_5370 = new actions.ScriptAction(
      {
        actionArgs: this.act_3343864469950044_script_5370_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_delete_5369 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_script_5370,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_3343864469950044_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_delete_5369],
      }
    );
    return {
      act_7315092382398562_closeModal_5360,
      evh_7315092382398562_close_5359,
      evh_7315092382398562_close,
      act_8320016629450276_reloadComponentData_5362,
      evh_8320016629450276_clickPreventStop_5361,
      evh_8320016629450276_clickPreventStop,
      act_6705964765214521_script_5364,
      evh_6705964765214521_clickPreventStop_5363,
      evh_6705964765214521_clickPreventStop,
      act_8116269939469002_showModal_5366,
      evh_8116269939469002_clickPreventStop_5365,
      evh_8116269939469002_clickPreventStop,
      act_3343864469950044_script_5368,
      evh_3343864469950044_save_5367,
      evh_3343864469950044_save,
      act_3343864469950044_script_5370,
      evh_3343864469950044_delete_5369,
      evh_3343864469950044_delete,
      reload: act_8320016629450276_reloadComponentData_5362,
    }
  }
}

Vue.component("JobSchedulerConfigurations", JobSchedulerConfigurations);

</script>